export default __webpack_public_path__ + "maps-examples-inset-map-thumbnail-960-e329cca71f68ab14ace04f3b91e80abc.webp";